import { ReadRole } from '../../../../services/gql/graphql.generated';
import strings from '../../team.translations';

enum legacyRoleMap {
  Admin = 'admin',
  Manager = 'manager',
  Staff = 'staff',
  SuperVisor = 'supervisor'
}

export const roleSelectOptions = (roles: ReadRole[]) => {
  return roles.map(role => {
    let roleName = role.name.replaceAll(' ', '').toLowerCase();
    roleName = Object.values(legacyRoleMap).find(value => roleName.includes(value)) as string;

    const descriptionIndex = Object.keys(strings.addTeamMemberForm).findIndex(
      key => key.toLowerCase() === `${roleName}description`
    );

    const descriptionValue = Object.values(strings.addTeamMemberForm)[descriptionIndex];
    const nameIndex = Object.keys(strings.addTeamMemberForm).findIndex(key => key.toLowerCase() === `${roleName}`);
    const nameValue = Object.values(strings.addTeamMemberForm)[nameIndex];

    return {
      key: role.id,
      value: role.name,
      description: descriptionIndex !== -1 ? descriptionValue.toString() : '',
      label: nameIndex !== -1 ? nameValue.toString() : role.name
    };
  });
};
